import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { Show } from 'src/app/shared/models/show';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-add-shows-modal',
  templateUrl: './add-shows-modal.component.html',
  styleUrls: ['./add-shows-modal.component.scss']
})
export class AddShowsModalComponent implements OnInit {

  //dynamic height settings to allow modal to grow
  containerHeight = '350px';
  contentHeight = '150px';
  showListHeight = '80px';

  partner: Partner;

  newShowName: string;

  //for adding multiple shows
  newShows: Show[] = [];

  constructor(private partnerService: PartnerService, private snackbarService: SnackBarService, public dialogRef: MatDialogRef<AddShowsModalComponent>) { }

  ngOnInit() {

    //track partner
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;
    })
  }

  onClose(): void {
    this.dialogRef.close();
  }

  addNewShow() {

    if (this.newShowName) {
      //create latest show name
      let show: Show = {
        id: 0,
        name: this.newShowName,
        isShared: false,
        seasons: [],
        partnerGroup: null
      };
      //add to list, whether it's the only one or not
      this.newShows.push(show);
    }


    if (this.newShows.length > 0) {
      //add all new shows to partner.shows
      this.partner.shows = this.partner.shows.concat(this.newShows);

      this.partnerService.updatePartner(this.partner).subscribe(
        (resPartner) => {
          this.partner = resPartner;

          //update selectedPartner
          this.partnerService.setSelectedPartner(this.partner);

          this.snackbarService.showSnackBarMessage("Show successfully added", "Close");

          this.onClose();
        },
        (error) => {
          //handle error
          this.snackbarService.showSnackBarMessage("An error occurred while attempting to add the show.", "Close", undefined, true);
        })
    }
    else {
      this.snackbarService.showSnackBarMessage("No show names have been added!", "Close", undefined, true);
    }


  }

  addShowToList() {

    if (this.newShowName) {

      if (this.newShows.find(item => item.name.toLowerCase() === this.newShowName.toLowerCase())) {
        this.snackbarService.showSnackBarMessage("Show name already added to list!", "Close", undefined, true);
      }
      else {
        //create latest show name
        let show: Show = {
          id: 0,
          name: this.newShowName,
          isShared: false,
          seasons: [],
          partnerGroup: null
        };

        this.newShows.push(show);

        this.newShowName = '';

        this.adjustModalSize();
      }

    }
    else {
      //display error message here if necessary
    }


  }

  removeShowFromList(show: Show) {
    let index = this.newShows.findIndex(item => item === show);

    if (index !== -1) {
      this.newShows.splice(index, 1);

      this.adjustModalSize();
    }
  }


  /**
   * Allows the modal to grow when adding shows to list
   */
  adjustModalSize() {

    if (this.newShows.length > 0) {
      let stockHeight = 450; //add an automatic 100 pixels so list will be displayed
      let contentHeight = 250; //add an automatic 100 pixels so list will be displayed
      let showListHeight = 80;

      this.newShows.forEach(item => {
        stockHeight += 30;  //add 30 pixels for each item
        contentHeight += 30;
        showListHeight += 30;
      });

      this.containerHeight = `${stockHeight}px`
      this.contentHeight = `${contentHeight}px`
      this.showListHeight = `${showListHeight}px`
    }
    else {
      this.containerHeight = '350px'
      this.contentHeight = '150px'
      this.showListHeight = '0px' //shouldn't be displayed anyways
    }
  }


}
